import React from 'react';
import { Modal } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sendTagging } from '../../../store/ducks/tagging/actions';

interface EndSessionProps {
  actionClick: () => void;
  loading: boolean;
  modalName: 'prestes_a_expirar' | 'sessao_expirada';
}

const ModalEndSession: React.FC<EndSessionProps> = ({
  actionClick,
  loading,
  modalName
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const handleBackLogin = () => {
    dispatch(
      sendTagging({
        event: 'sessao_encerrada',
        screenName: location.pathname,
        ecommerce: {
          modal_name: modalName
        }
      })
    );
    actionClick();
  };

  return (
    <Modal
      buttons={{
        right: {
          children: 'Voltar ao login',
          name: 'back-login',
          onClick: handleBackLogin,
          type: 'button',
          variant: 'primary',
          loading
        }
      }}
      modalSize="sm"
      title="Sua sessão foi encerrada"
    >
      <span>Por segurança, sua sessão foi encerrada devido à inatividade.</span>
    </Modal>
  );
};

export default ModalEndSession;
